import { FieldTypeDropdownKeys } from "src/components/Inputs/types/IFieldTypeDropdown"

export const supportsHiding = (fieldType: string): boolean => {
    // All field types except file upload can be hidden
    return fieldType !== FieldTypeDropdownKeys.FileUpload
}

export const supportsFallbackOption = (fieldType: string): boolean => {
    // Only radio, checkbox, and dropdown support fallback options
    return (
        fieldType === FieldTypeDropdownKeys.RadioButton ||
        fieldType === FieldTypeDropdownKeys.Checkbox ||
        fieldType === FieldTypeDropdownKeys.Dropdown
    )
}
